module.exports = __webpack_public_path__ + "img/frontend.45d77801.svg";